<div class="component-wrapper">
  <div class="text-id-missing">STORE ID MISSING</div>
  <section>
    <app-footer></app-footer>
  </section>
</div>
